<template>
    <select class="custom-select" :value="value" @input="$emit('input', $event.target.value)">
        <slot>
            <option v-for="option in options" :value="option.id" :key="option.id">{{ option.label }}</option>
        </slot>
    </select>
</template>

<script>
export default {
    props: ['value', 'options']
}
</script>